module.exports = __webpack_public_path__ + "../static/img/autobackups_mini.6010f790.png";